import type { KeyedMutator, SWRConfiguration } from 'swr';
import useSWR from 'swr';

import type { ErrorCustom } from '@/utils/client';
import { get } from '@/utils/client';

import type { UserType } from '@/types/userType';

import { USER } from '@/routes/apiEndpoints';

export type MutateUserType = KeyedMutator<UserType>;

const useUser = (options?: SWRConfiguration<UserType, ErrorCustom>) => {
    const {
        data,
        mutate: mutateUser,
        error: userError,
        isLoading
    } = useSWR<UserType, ErrorCustom>(USER, (url) => get(url).then((res) => res.data), {
        shouldRetryOnError: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        ...options
    });

    return {
        user: data,
        mutateUser,
        userError,
        isLoading
    };
};
export default useUser;
